module.exports = __webpack_public_path__ + "img/q-pattern.d6804e6b.png";